import styled from "styled-components";

const Spinner = styled.div`
  width: 100%;
  height: 200px;
  position: relative;
  height: 104px;
  border-radius: 5px;
  &:before {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 20px;
    height: 20px;
    margin-top: -10px;
    margin-left: -10px;
    border: 3px solid rgba(0, 0, 0, 0.2);
    border-radius: 50%;
    border-top-color: rgba(0, 0, 0, 0.6);
    border-right-color: rgba(0, 0, 0, 0.6);
    box-sizing: border-box;
    animation: spinner-animation 0.65s infinite linear;
  }
  @keyframes spinner-animation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export default Spinner;



// WEBPACK FOOTER //
// ./frontend/src/common/components/atoms/Spinner.tsx